import { render, staticRenderFns } from "./eventRegistration.vue?vue&type=template&id=27d0a564&scoped=true&"
import script from "./eventRegistration.vue?vue&type=script&lang=js&"
export * from "./eventRegistration.vue?vue&type=script&lang=js&"
import style0 from "./eventRegistration.vue?vue&type=style&index=0&id=27d0a564&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d0a564",
  null
  
)

export default component.exports